/**
 * OS generator
 * for getting device OS
 * @returns {string}
 */
export const getOS = () => {
  let os = '';
  const userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};

/**
 * Set Initial Sys.Ui Counter
 */
export const InitialSysUiCounter = () => {
  const indexSession = {
    web_stamp_card: 0,
    flash_market: 0,
    web_store_telemetric: 0,
    web_promo_code: 0,
    web_interstitials: 0,
    web_following_event: 0,
  };
  if (!sessionStorage.getItem('index')) {
    sessionStorage.setItem('index', JSON.stringify(indexSession));
  }
};

/**
 * Set Event counter flow_name
 * for getting sys.ui event count
 */
export const setEventCounter = (flow_name: unknown) => {
  try {
    if (typeof flow_name !== 'string') return;
    const index = sessionStorage.getItem('index');
    if (index) {
      const indexSession = JSON.parse(index) || {};
      indexSession[flow_name]++;
      sessionStorage.setItem('index', JSON.stringify(indexSession));
    }
  } catch {
    //
  }
};

/**
 * Set Event counter flow_name
 * for getting sys.ui event count
 */
export const setEventCounterZero = (flow_name: string) => {
  try {
    const index = sessionStorage.getItem('index');
    if (index) {
      const indexSession = JSON.parse(index) || {};
      indexSession[flow_name] = 0;
      sessionStorage.setItem('index', JSON.stringify(indexSession));
    }
  } catch {
    //
  }
};

/**
 * Get Event Count for sys.ui flow_name
 */
export const getEventCounter = (flow_name: unknown) => {
  try {
    if (typeof flow_name !== 'string') return 0;
    const index = sessionStorage.getItem('index');
    if (index == null) return 0;
    return +JSON.parse(index)[flow_name];
  } catch {
    return 0;
  }
};
